// In-app self-service account page — change your own password + email preferences.
import { useState } from "react";
import { UserCog, Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ChangePasswordForm from "./ChangePasswordForm";
import { EmailNotificationSwitches } from "@/components/EmailNotificationSwitches";

export default function AccountPage() {
    const { user } = useAuth();
    const [optOut, setOptOut] = useState(user?.email_opt_out_categories || []);
    const [busy, setBusy] = useState(false);

    async function saveEmailPrefs() {
        setBusy(true);
        try {
            await api.patch("/auth/me", { email_opt_out_categories: optOut });
            toast.success("Email preferences saved");
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail) || "Could not save");
        }
        setBusy(false);
    }

    return (
        <div className="space-y-5 max-w-[480px]" data-testid="account-page">
            <div>
                <span className="inline-block pb-1 text-[10.5px] font-bold tracking-[.08em] uppercase" style={{ borderBottom: "2px solid #C75A1B", color: "#6F6A64" }}>Account</span>
                <h2 className="text-2xl font-bold tracking-tight mt-2 text-[#1F1F1F] flex items-center gap-2">
                    <UserCog className="w-6 h-6" style={{ color: "#C75A1B" }} /> My account
                </h2>
                <p className="text-[13px] mt-1" style={{ color: "#6F6A64" }}>{user?.name} · {user?.email}</p>
            </div>
            <div className="bg-white border rounded-[12px] p-6" style={{ borderColor: "#E5E0DA" }}>
                <h3 className="text-[14px] font-semibold text-[#1F1F1F] mb-4">Change password</h3>
                <ChangePasswordForm />
            </div>
            <div className="bg-white border rounded-[12px] p-6" style={{ borderColor: "#E5E0DA" }}>
                <EmailNotificationSwitches value={optOut} onChange={setOptOut} />
                <button data-testid="account-save-email-prefs" onClick={saveEmailPrefs} disabled={busy}
                    className="mt-4 inline-flex items-center gap-1.5 px-4 py-2 rounded-[8px] text-[12.5px] font-semibold text-white"
                    style={{ background: "var(--brand-accent,#C75A1B)" }}>
                    {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />} Save preferences
                </button>
            </div>
        </div>
    );
}
